import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {LoadingService} from "../../../service/loading.service";

@Component({
    selector: 'app-loading-component',
    templateUrl: './loading.component.html',
    standalone: false
})
export class LoadingComponent implements OnInit, OnDestroy {

  isLoading: boolean
  loadingSubscription: Subscription

  constructor(
    private loadingService: LoadingService
  ) {
  }

  ngOnInit() {
    this.loadingSubscription = this.loadingService._isLoading.subscribe(value => this.isLoading = value)
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe()
  }

}
